import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { fromJS } from 'immutable';

import { Step1 } from '../NewSurvey/form/Step1';
import { StepLink } from './form/StepLink';
import { StepNewProductList } from './form/StepNewProductList';

const WizardForm = ({
  commercialProducts,
  product,
  strings,
  dateFormat,
  handleFetchProducts,
  handleSelectProduct,
  handleGetRoute,
}) => {
  const [commercialProductGroup, setCommercialProductGroup] = useState(undefined);
  const [commercialProduct, setCommercialProduct] = useState(undefined);
  const selectCommercialProductGroupHandlder = id => {
    setCommercialProductGroup(id);
    setCommercialProduct(undefined)
  };
  const commercialProductsGroups = commercialProducts?.filter(commProd => commProd.get('type') !== 'link');
  const linkCommProd = commercialProducts?.filter(commProd => commProd.get('type') === 'link');

  const handjeSelectCPChange = option => {
    setCommercialProduct(option);
  }

  return (
    <>
      <Step1
        id="step1"
        surveys={commercialProductsGroups}
        survey={setCommercialProductGroup}
        setSurvey={selectCommercialProductGroupHandlder}
      />
      <StepLink id="steplink" commercialProducts={linkCommProd} strings={strings} handleGetRoute={handleGetRoute} />
      <StepNewProductList
        id="stepproductlist"
        strings={strings}
        dateFormat={dateFormat}
        commercialProducts={commercialProductsGroups}
        selectedCommercialProductGroup={commercialProductGroup}
        selectedCommercialProduct={commercialProduct}
        product={product}
        handleFetchProducts={handleFetchProducts}
        handleSelectProduct={handleSelectProduct}
        handleDateChange={params => console.log('Wizard::handleFetchProducts:', params)}
        handleSelectCPChange={handjeSelectCPChange}
        handleButtonClick={params => console.log('Wizard::handleButtonClick:', params)}
      />
    </>
  );
};

WizardForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  commercialProducts: PropTypes.object,
  product: PropTypes.shape({
    label: PropTypes.string,
    placeholder: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }),
  strings: PropTypes.objectOf(PropTypes.string),
  dateFormat: PropTypes.string,
  handleFetchProducts: PropTypes.func,
  handleSelectProduct: PropTypes.func,
  handleGetRoute: PropTypes.func,
};

WizardForm.defaultProps = {
  commercialProducts: fromJS({}),
  product: {
    title: 'product.title',
    subtitle: 'product.subtitle',
    label: 'product.select.label',
    placeholder: 'product.select.placeholder',
  },
  strings: {},
  dateFormat: 'YYYY-MM-DD',
  handleFetchProducts: params => console.log('WizardForm:handleFetchProducts ::', params),
  handleSelectProduct: params => console.log('WizardForm:handleSelectProduct ::', params),
  handleGetRoute: params => console.log('WizardForm:handleGetRoute ::', params),
};

export default WizardForm;
